import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useGetOwnerLogo } from 'services/settings/individual/logo';
import { IChildrenProp } from 'types/components/components.interface';
import { useStoreState } from './StoreStateContext';

const LogoProvider = ({ children }: IChildrenProp) => {
  const ownerLogoData = useGetOwnerLogo();

  const { ownerLogo, setOwnerLogo } = useStoreState();

  useEffect(() => {
    if (
      ownerLogoData.data?.showOwnersLogoAsMain === true &&
      ownerLogo?.pictureLink !== ownerLogoData.data?.pictureLink
    ) {
      setOwnerLogo(ownerLogoData.data);
    }

    if (ownerLogoData.data?.showOwnersLogoAsMain === false) {
      setOwnerLogo(null);
    }
  }, [ownerLogoData.data?.pictureLink, undefined]);
  return (
    <>
      <Helmet>
        <link
          rel='icon'
          href={
            ownerLogo?.pictureLink ??
            `${process.env.PUBLIC_URL}/icons/magellup_icon.png`
          }
        />
        <link
          rel='apple-touch-icon'
          href={
            ownerLogo?.pictureLink ??
            `${process.env.PUBLIC_URL}/icons/magellup_icon.png`
          }
        />
      </Helmet>
      {children}
    </>
  );
};

export default LogoProvider;
